const INITIAL_VOLUME = 0.2;

export { INITIAL_VOLUME };
